export default {
  __html: `<g fill="none" fill-rule="evenodd">
  <path fill="#292663" d="M5 6a1 1 0 0 0-1 1v9.2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5zm0-1.8h14A2.8 2.8 0 0 1 21.8 7v9.2A2.8 2.8 0 0 1 19 19H5a2.8 2.8 0 0 1-2.8-2.8V7A2.8 2.8 0 0 1 5 4.2zm1.35 3.4a.75.75 0 0 0-.75.75v6.5c0 .414.336.75.75.75h.1a.75.75 0 0 0 .75-.75v-6.5a.75.75 0 0 0-.75-.75h-.1zm2.4 0a.75.75 0 0 0-.75.75v6.5c0 .414.336.75.75.75h.1a.75.75 0 0 0 .75-.75v-6.5a.75.75 0 0 0-.75-.75h-.1zm3.2 0h.1a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75h-.1a.75.75 0 0 1-.75-.75v-6.5a.75.75 0 0 1 .75-.75zm3.2 0h.1a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75h-.1a.75.75 0 0 1-.75-.75v-6.5a.75.75 0 0 1 .75-.75zm2.4 0h.1a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75h-.1a.75.75 0 0 1-.75-.75v-6.5a.75.75 0 0 1 .75-.75z"/>
            </g>`
}



// WEBPACK FOOTER //
// ./src/app/elements/Icon/barcode.js